export default ({
    name : 'HamburgerMenu'
    , props : {
        'profileIconColorClass' : String // common_header computed value.
    }
    , data () {
        return {}
    },
    created () {
        this.code = 'hamburger_menu';
        this.basic = this.getDetailDataByCode(this.code);
        return {}
    },
    computed : {
    }
})
